import * as types from '../mutation_types';
import router from '@views/home/router';
import axios from 'axios';

const debug = false;
const debugGetParkingSpace = debug;

export default {
  getParkingSpace({commit, state, dispatch, rootState}, payload) {
    return new Promise((resolve, reject) => {
      dispatch('setLoading', true, {root: true});

      let call;
      if (debugGetParkingSpace) {
        call = import('@fixtures/parking-space-fixture');
      } else {
        const token = router.app.$context.token;
        call = axios.get(`/api/v1/parking-space/${payload.parking_space_id}/?date=${payload.date}`, {
          headers: {
            Authorization: `Token ${token}`
          }
        });
      }
      call.then(response => {
        dispatch('parkingSpace/setParkingSpace', response.data, {root: true});
        resolve(response.data);
        dispatch('setLoading', false, {root: true});
      }).catch(err => {
        reject(err);
        dispatch('setLoading', false, {root: true});
      });
    });
  },
  setParkingSpace({commit}, payload) {
    return new Promise((resolve, reject) => {
      try {
        commit(types.SET_PARKING_SPACE, payload);
        resolve();
      } catch (e) {
        console.log(e);
        reject(e);
      }
    });
  },
  setBooking({commit, state, dispatch, rootState}, payload) {
    return new Promise((resolve, reject) => {
      dispatch('setLoading', true, {root: true});

      const token = router.app.$context.token;
      axios.post(`/api/v1/parking-space-reservation/`, payload, {
        headers: {
          Authorization: `Token ${token}`
        }
      }).then(response => {
        resolve(response.data);
        dispatch('setLoading', false, {root: true});
      }).catch(err => {
        reject(err);
        dispatch('setLoading', false, {root: true});
      });
    });
  }
};
